<template>
  <div class="components-container">
    <header>
      <span class="title">发布平台消息</span>
      <div class="right">
        <!-- <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input> -->
        <el-button type="primary" @click="AddDialog" v-if="funAuth.includes(63)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @row-click="rowClick" @selection-change='handleSelectionChange'>
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column label='消息开始时间' min-width='100'>
        <template slot-scope='scope'>{{ scope.row.start_time | formatDate('yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column label='消息结束时间' min-width='100'>
        <template slot-scope='scope'>{{ scope.row.end_time | formatDate('yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column label='通知对象' min-width='180' :show-overflow-tooltip="true">
        <template slot-scope='scope'>
          {{scope.row.notice_type_label}}:{{scope.row.notice_type_value_label}}
        </template>
      </el-table-column>
      <el-table-column prop='txt' label='发布内容' min-width='240' :show-overflow-tooltip="true" popper-class="a1312313">
        <!-- <template slot-scope='scope'>
          <span v-text="scope.row.content"></span>
        </template> -->
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n1" v-if="dialogDetail" @click="dialogDetail = false"></div>
    <transition name="slide">
      <el-container class="data-detail-wrip" v-if="dialogDetail">
        <header>
          <img src="/static/images/icon-company.png">
          平台消息
          <i class="iconfont icon-close" @click="dialogDetail = false"></i>
        </header>
        <div class="tab-box">
          <div class="tab-item" :class="(tabType == 0)?'active':''" @click="dtlChange(0)"><span>基本资料</span></div>
          <div class="tab-item" :class="(tabType == 1)?'active':''" @click="dtlChange(1)"><span>操作记录</span></div>
        </div>
        <div class="head" v-if="tabType == 0">
          <span>基本资料</span>
          <el-dropdown trigger="click" @command="handleCommand" v-if="funAuth.includes(65)">
            <span class="el-dropdown-link">
              <i class="el-icon-arrow-down el-icon-more"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">删  除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button type="primary" @click="editDialog" v-if="funAuth.includes(64)">编 辑</el-button>
        </div>
        <div class="head" v-if="tabType == 1">
          <span>操作记录</span>
        </div>
        <div class="content">
          <el-collapse v-model="activeNames" v-if="tabType == 0">
            <el-collapse-item name="1">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                基本信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">消息开始时间</span>
                  <div class="item-content">{{messageDetail.start_time | formatDate('yyyy-MM-dd')}}</div>
                </div>
                <div class="item">
                  <span class="title">消息结束时间</span>
                  <div class="item-content">{{messageDetail.end_time | formatDate('yyyy-MM-dd')}}</div>
                </div>
                <div class="item single">
                  <span class="title">通知对象</span>
                  <div class="item-content">{{messageDetail.notice_type_label}}：{{messageDetail.notice_type_value_label}}</div>
                </div>
                <div class="item">
                  <span class="title">更新版本号</span>
                  <div class="item-content">{{messageDetail.release_version}}</div>
                </div>
                <div class="item single">
                  <span class="title">文本说明</span>
                  <div class="item-content">{{messageDetail.release_describe}}</div>
                </div>
                <div class="item single">
                  <span class="title">发布内容</span>
                  <div class="item-content" v-html="messageDetail.content"></div>
                </div>
              </div>
            </el-collapse-item>
            <el-collapse-item name="2">
              <template slot="title">
                <i class="iconfont icon-zhankai"></i>
                系统信息
              </template>
              <div class="form">
                <div class="item">
                  <span class="title">创建人</span>
                  <div class="item-content">{{messageDetail.create_by}}</div>
                </div>
                <div class="item">
                  <span class="title">创建时间</span>
                  <div class="item-content">{{messageDetail.create_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
                <div class="item">
                  <span class="title">修改人</span>
                  <div class="item-content">{{messageDetail.modify_by}}</div>
                </div>
                <div class="item">
                  <span class="title">修改时间</span>
                  <div class="item-content">{{messageDetail.modify_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <div class="log-box" v-if="tabType == 1">
            <div class="log-item" v-for="(date, index) in logList" :key="index">
              <div class="line">
                <div class="circle"></div>
              </div>
              <div class="rihgt">
                <div class="time">{{date.datetime_time | formatDate('yyyy-MM-dd HH:mm')}}</div>
                <div class="content">{{date.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </el-container>
    </transition>

    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <el-container class="add-dialog" v-if="dialogAdd">
        <header>
          <span>新增</span>
          <i class="iconfont icon-close" @click="dialogAdd = false"></i>
        </header>
        <div class="content">
          <div class="banner">
            <div class="h1">发布平台消息</div>
            <div class="h2">用于对平台客户的消息通知，在消息时间范围内平台客户都会收到该消息内容。</div>
          </div>
          <div class="form">
            <div class="form-header">基本信息</div>
            <div class="form-content">
              <div class="form-item">
                <span class="item-title item-title2"><span><span class="need">*</span>消息</span><span>开始时间</span></span>
                <div class="item-right">
                  <el-date-picker v-model="startTime" type="date" placeholder="选择日期" value-format="timestamp" @change="timeChange(0)"></el-date-picker>
                </div>
                <div class="err" v-if="err_st"><i class="el-icon-warning"></i>{{err_st}}</div>
              </div>
              <div class="form-item">
                <span class="item-title item-title2"><span><span class="need">*</span>消息</span><span>结束时间</span></span>
                <div class="item-right">
                  <el-date-picker v-model="endTime" type="date" placeholder="选择日期" value-format="timestamp" @change="timeChange(1)"></el-date-picker>
                </div>
                <div class="err" v-if="err_et"><i class="el-icon-warning"></i>{{err_et}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>通知对象</span>
                <div class="item-right">
                  <el-select v-model="notice_type" @change="noticeChange" placeholder="请选择(必填)" style="width: calc(50% - 50px);margin-right: 12px;">
                    <el-option v-for="item in option" :key="item.id" :label="item.label" :value="item.id"></el-option>
                  </el-select>
                  <el-select v-model="notice_type_value" placeholder="请选择(必填)" filterable multiple collapse-tags style="width:calc(50% + 32px);">
                    <el-option v-for="item in option2" :key="item.id" :label="item.label" :value="item.id" v-if="notice_type==0"></el-option>
                    <el-option v-for="item in option2" :key="item.id" :label="item.version_name" :value="item.id" v-if="notice_type==1&&item.status==0"></el-option>
                    <el-option v-for="item in option2" :key="item.id" :label="item.cm_name" :value="item.id" v-if="notice_type==2&&item.cm_state==1"></el-option>
                    <el-option v-for="item in option2" :key="item.id" :label="item.company_name" :value="item.id" v-if="notice_type==3"></el-option>
                  </el-select>
                </div>
                <div class="err" v-if="err_ntv"><i class="el-icon-warning"></i>{{err_ntv}}</div>
              </div>
              <div class="form-item">
                <span class="item-title"><span class="need">*</span>更新版本号</span>
                <div class="item-right">
                  <el-input v-model="release_version" placeholder="请输入" :maxlength="25"></el-input>
                </div>
                <div class="err" v-if="err_rv"><i class="el-icon-warning"></i>{{err_rv}}</div>
              </div>
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>文本说明</span>
                <div class="item-right">
                  <el-input type="textarea" v-model="release_describe" placeholder="请输入" :rows="3" resize="none" :maxlength="500"></el-input>
                </div>
                <div class="err" v-if="err_rd"><i class="el-icon-warning"></i>{{err_rd}}</div>
              </div>
              <div class="form-item single" style="margin: -15px 0;">
                <span class="item-title"></span>
                <div class="item-right">
                  <el-button type="text" @click="multilingual">多语言设置</el-button>
                </div>
              </div>
              <div class="form-item single">
                <span class="item-title"><span class="need">*</span>发布内容</span>
                <div class="item-right">
                  <!-- <el-input type="textarea" v-model="content" placeholder="请输入" size="medium" :rows="3" resize="none" :maxlength="500"></el-input> -->
                  <ueditor :editorContent="editorContent" :isEdit="true" :maximumWords="500" :moduleId="moduleId" v-if="dialogAdd"></ueditor>
                </div>
                <div class="err" v-if="err_c"><i class="el-icon-warning"></i>{{err_c}}</div>
              </div>
            </div>
          </div>
        </div>
        <footer>
          <el-button @click="dialogAdd = false">取 消</el-button>
          <el-button type="primary" @click="dialogSave">保 存</el-button>
        </footer>
      </el-container>
    </transition>
    <el-dialog title="提示" :visible.sync="dialogDelete" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <div class="note">删除后该消息将不可用。</div>
      <div class="prompt">确定要删除该消息吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogDelete = false">取 消</el-button>
        <el-button type="primary" @click="userDelete">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="多语言设置" :visible.sync="multilingualDialog" width="800px" append-to-body :close-on-click-modal="false" class="multilingualDialog">
      <el-table :data="multiData" border style="width: 100%" v-if="multilingualDialog">
        <el-table-column label="语种" min-width="80">
          <template slot-scope="scope">
            {{scope.row.fixedLabel}}
            <!-- <el-select v-model="scope.row.language" placeholder="选择语言">
              <el-option v-for="item in languageList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </template>
        </el-table-column>
        <el-table-column label="文本说明" min-width='160'>
          <template slot-scope="scope">
            <el-input type="textarea" v-model="scope.row.release_describe" placeholder="请输入" :rows="6" resize="none" :maxlength="500"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="发布内容" min-width='180'>
          <template slot-scope="scope">
            <ueditor :editorContent="scope.row.editorContent" :isEdit="true" :maximumWords="500" :minH="160" :moduleId="'multi_' + scope.$index" v-if="multilingualDialog"></ueditor>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width='32'>
          <template slot-scope="scope">
            <el-button type="text" :disabled="scope.$index==0" @click="removemulti(scope.$index, scope.row.value)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="add-language-btn">
        <el-dropdown trigger="click" placement="bottom-start">
          <span class="el-dropdown-link">
            添加语言
          </span>
          <el-dropdown-menu slot="dropdown" class="choose-language-box">
            <template v-for="v in languageList">
              <el-dropdown-item :disabled="haveLanguage.includes(v.value)" :key="v.value" @click.native="setLanguage(v)">
                <div>
                  <span class="span1">{{v.fixedLabel}}</span>
                  <span class="span2">{{v.label}}</span>
                </div>
              </el-dropdown-item>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="multilingualDialog = false">取 消</el-button>
        <el-button type="primary" @click="savemulti">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mixin from '@/common/js/mixins.js'
import {HTTPServer} from '@/common/js/ajax.js'
import { language } from '@/common/js/constant.js'
import ueditor from '@/common/components/ueditor.vue'

export default {
  data () {
    return {
      defaultMsg: '<b>发布平台消息</b>',
      disabled: true,
      tableList: [],
      moduleId: 19,
      pageSize: 20,
      pageNum: 1,
      tableTotal: 0,
      searchInput: '',
      option: [{'label': '部署方式', 'id': '0'}, {'label': '开通版本', 'id': '1'}, {'label': '组件版本', 'id': '2'}, {'label': '客户', 'id': '3'}],
      option2: [{'label': '云端', 'id': '0'}, {'label': '本地化', 'id': '1'}],
      dialogDetail: false,
      messageDetail: {},
      tabType: 0,
      dialogAdd: false,
      startTime: '',
      err_st: '',
      endTime: '',
      err_et: '',
      notice_type: '', // 通知对象
      notice_type_value: [], // 通知对象值
      err_ntv: '',
      content: '', // 编辑器内容
      editorContent: '<p></p>', // 设置编辑器内容
      getContentTxt: '',
      err_c: '',
      release_version: '',
      err_rv: '',
      release_describe: '',
      err_rd: '',
      dialogDelete: false,
      language: language,
      languageList: [
        {fixedLabel: '简体中文', label: '简体中文', value: 'zh'},
        {fixedLabel: 'Englist', label: '英语', value: 'en'},
        {fixedLabel: '繁體中文', label: '繁体中文', value: 'zh_TW'}
      ],
      multilingualDialog: false,
      haveLanguage: ['zh'],
      multiData: [{fixedLabel: '简体中文', language: 'zh', release_describe: ''}]
    }
  },
  mixins: [mixin],
  components: {
    ueditor
  },
  created () {
  },
  /* 页面加载后执行 */
  mounted () {
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    this.queryReleaseNoticeList()
    this.$bus.on('editorContents', (value, id) => {
      // console.log(12313, id, value)
      if (id === 19) {
        this.content = value
        this.multiData[0].content = value
      } else if (id && id.includes('multi_')) {
        var index = parseInt(id.split('_')[1])
        console.log(111111, this.multiData[index])
        this.multiData[index].content = value
      }
    })
    this.$bus.on('getContentTxt', (value, id) => {
      // console.log(12313, id, value)
      if (id === 19) {
        this.getContentTxt = value
        this.multiData[0].contentTxt = value
      } else if (id && id.includes('multi_')) {
        var index = parseInt(id.split('_')[1])
        console.log(111111, this.multiData[index])
        this.multiData[index].contentTxt = value
      }
    })
  },
  methods: {
    noticeChange (value) {
      if (value) {
        this.notice_type_value = []
      }
      var jsondata = {'pageNum': 1, 'pageSize': 999}
      if (this.notice_type === '0') {
        this.option2 = [{'label': '云端', 'id': 0}, {'label': '本地化', 'id': 1}]
      } else if (this.notice_type === '1') {
        HTTPServer.queryChargingStrategyList(jsondata, 'Loading').then((res) => {
          this.option2 = res.dataList
        })
      } else if (this.notice_type === '2') {
        HTTPServer.getComponentManageList(jsondata, 'Loading').then((res) => {
          this.option2 = res.dataList
        })
      } else if (this.notice_type === '3') {
        HTTPServer.queryFormalUserList(jsondata, 'Loading').then((res) => {
          this.option2 = res.dataList
          HTTPServer.queryTrialUserList(jsondata, 'Loading').then((res) => {
            this.option2 = [...this.option2, ...res.dataList]
          })
        })
      }
    },
    timeChange (type) {
      if (type === 0) {
        this.startTime = new Date(this.startTime).setHours(0, 0, 0, 0)
      } else if (type === 1) {
        this.endTime = new Date(this.endTime).setHours(23, 59, 59, 999)
      }
    },
    /** 获取平台消息列表 */
    queryReleaseNoticeList (id) {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryReleaseNoticeList(jsondata, 'Loading').then((res) => {
        res.dataList.map(v => {
          var dom = document.createElement('DIV')
          // v5.7.4
          if (v.release_describe) {
            var obj = JSON.parse(JSON.stringify(v))
            obj.content = JSON.parse(obj.content)
            obj.release_describe = JSON.parse(obj.release_describe)
            dom.innerHTML = obj.content.language.zh
          } else {
            dom.innerHTML = v.content
          }
          v.txt = dom.innerText
        })
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
        if (id) {
          let copy = res.dataList.find(v => {
            return v.id === id
          })
          if (copy) {
            copy = JSON.parse(JSON.stringify(copy))
            // v5.7.4
            if (copy.release_describe) {
              this.multiData = []
              copy.release_describe = JSON.parse(copy.release_describe)
              copy.content = JSON.parse(copy.content)
              for (const key in copy.content.language) {
                let label = this.languageList.find(v => {
                  return v.value === key
                })
                let obj = {
                  fixedLabel: label.fixedLabel,
                  language: key,
                  release_describe: copy.release_describe.language[key],
                  content: copy.content.language[key],
                  editorContent: copy.content.language[key],
                  contentTxt: ''
                }
                if (key === 'zh') {
                  this.multiData.unshift(obj)
                } else {
                  this.multiData.push(obj)
                }
              }
              copy.content = copy.content.language.zh
              copy.release_describe = copy.release_describe.language.zh
            }
            this.messageDetail = copy
          }
        }
      })
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryReleaseNoticeList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryReleaseNoticeList()
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryReleaseNoticeList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    AddDialog () {
      this.startTime = ''
      this.endTime = ''
      this.notice_type = '0'
      this.notice_type_value = []
      this.release_version = ''
      this.release_describe = '为了进一步提高系统服务质量，Teamface企典将于本周五（2020年8月5日）18:00～20:00进行系统升级，系统升级期间，会影响Teamface企典的使用，请您提前做好准备，所有功能将在升级结束后恢复，不便之处敬请谅解。'
      this.content = ''
      this.editorContent = '<p></p>'
      this.err_st = ''
      this.err_et = ''
      this.err_rv = ''
      this.err_rd = ''
      this.err_c = ''
      this.err_ntv = ''
      this.multiData = [{
        fixedLabel: '简体中文',
        language: 'zh',
        release_describe: this.release_describe,
        content: '',
        contentTxt: ''
      }]
      this.dialogAdd = true
    },
    editDialog () {
      let data = JSON.parse(JSON.stringify(this.messageDetail))
      this.startTime = data.start_time
      this.endTime = data.end_time
      this.notice_type = data.notice_type.toString() || '0'
      this.release_version = data.release_version
      this.notice_type_value = []
      if (data.notice_type_value) {
        data.notice_type_value.split(',').map(v => {
          this.notice_type_value.push(parseInt(v))
        })
      }
      this.release_describe = data.release_describe
      this.content = data.content
      this.editorContent = JSON.parse(JSON.stringify(data.content))

      this.noticeChange()
      this.err_st = ''
      this.err_et = ''
      this.err_rv = ''
      this.err_rd = ''
      this.err_c = ''
      this.err_ntv = ''
      this.dialogAdd = true
      console.log(this.multiData)
    },
    /** 进入详情 */
    rowClick (row, event, column) {
      this.activeNames = ['1', '2', '3']
      let copy = JSON.parse(JSON.stringify(row))
      this.multiData = []
      // v5.7.4
      if (copy.release_describe) {
        copy.release_describe = JSON.parse(copy.release_describe)
        copy.content = JSON.parse(copy.content)
        for (const key in copy.content.language) {
          let label = this.languageList.find(v => {
            return v.value === key
          })
          let obj = {
            fixedLabel: label.fixedLabel,
            language: key,
            release_describe: copy.release_describe.language[key],
            content: copy.content.language[key],
            editorContent: copy.content.language[key],
            contentTxt: ''
          }
          if (key === 'zh') {
            this.multiData.unshift(obj)
          } else {
            this.multiData.push(obj)
          }
        }
        copy.content = copy.content.language.zh
        copy.release_describe = copy.release_describe.language.zh
      } else {
        this.multiData = [{fixedLabel: '简体中文', language: 'zh', release_describe: ''}]
      }
      this.messageDetail = copy
      this.tabType = 0
      this.dialogDetail = true
      console.log(this.multiData)
    },
    /** 详情导航切换 */
    dtlChange (type) {
      this.tabType = type
      if (type === 1) {
        this.queryRecordList({moduleType: this.moduleId, moduleId: this.messageDetail.id})
      }
    },
    dialogSave () {
      if (!this.startTime) {
        this.err_st = '消息开始时间不能为空'
        return false
      }
      if (!this.endTime) {
        this.err_et = '消息结束时间不能为空'
        return false
      }
      if (this.startTime > this.endTime) {
        this.err_et = '消息开始时间不能大于消息结束时间'
        return
      }
      if (this.notice_type_value.length === 0) {
        this.err_ntv = '通知对象不能为空'
        return false
      }
      if (!this.release_version) {
        this.err_c = '更新版本号不能为空'
        return false
      }
      if (!this.release_describe) {
        this.err_c = '文本说明不能为空'
        return false
      }
      if (!this.content) {
        this.err_c = '发布内容不能为空'
        return false
      }
      if (this.getContentTxt.length > 500) {
        this.err_c = '发布内容字符不能超过500字'
        return false
      }
      // let jsondata = {'start_time': this.startTime, 'end_time': this.endTime, 'notice_type': this.notice_type, 'notice_type_value': this.notice_type_value.toString(), 'content': this.content, 'notice_url': '', 'release_version': this.release_version, 'release_describe': this.release_describe}
      let jsondata = {
        'start_time': this.startTime,
        'end_time': this.endTime,
        'notice_type': this.notice_type,
        'notice_type_value': this.notice_type_value.toString(),
        'notice_url': '',
        'release_version': this.release_version,
        'release_describe': {
          label: '文本说明',
          language: {}
        },
        'content': {
          label: '发布内容',
          language: {}
        }
      }
      this.multiData.map(v => {
        jsondata.release_describe.language[v.language] = v.language === 'zh' ? this.release_describe : v.release_describe
        jsondata.content.language[v.language] = v.language === 'zh' ? this.content : v.release_describe
      })
      console.log(jsondata)
      if (this.dialogDetail) {
        jsondata.id = this.messageDetail.id
        HTTPServer.modifyReleaseNotice(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          // this.messageDetail.start_time = jsondata.start_time
          // this.messageDetail.end_time = jsondata.end_time
          // this.messageDetail.notice_type = jsondata.notice_type
          // this.messageDetail.content = jsondata.content
          this.dialogAdd = false
          this.queryReleaseNoticeList(jsondata.id)
        })
      } else {
        HTTPServer.addReleaseNotice(jsondata, 'Loading').then((res) => {
          this.$message({
            showClose: true,
            message: '保存成功！',
            type: 'success'
          })
          this.dialogAdd = false
          this.queryReleaseNoticeList()
        })
      }
    },
    /** 点击菜单项触发的事件回调 */
    handleCommand (cmd) {
      if (cmd === '1') {
        this.dialogDelete = true
      }
    },
    /** 邀请码 - 删除 */
    userDelete () {
      let arr = []
      if (this.dialogDetail) {
        arr.push(this.messageDetail.id)
      } else {
        this.multipleSelection.map((item) => {
          arr.push(item.id)
        })
      }
      HTTPServer.deleteReleaseNotice({id: arr.toString()}, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.dialogDetail = false
        this.dialogDelete = false
        this.pageNum = 1
        this.queryReleaseNoticeList()
      })
    },
    multilingual () {
      this.multiData[0].content = this.content
      this.multiData[0].editorContent = this.content
      this.multiData[0].contentTxt = this.getContentTxt
      this.multiData[0].release_describe = this.release_describe
      this.haveLanguage = []
      this.multiData.map(v => {
        v.editorContent = v.content
        this.haveLanguage.push(v.language)
      })
      console.log(this.multiData)
      this.multilingualDialog = true
    },
    // 设置语言
    setLanguage (v) {
      this.haveLanguage.push(v.value)
      this.multiData.push({
        fixedLabel: v.fixedLabel,
        language: v.value,
        release_describe: '',
        content: '',
        editorContent: '',
        contentTxt: ''
      })
    },
    removemulti (index, value) {
      this.multiData.splice(index, 1)
      this.haveLanguage = []
      this.multiData.map(v => {
        this.haveLanguage.push(v.language)
      })
    },
    savemulti () {
      let err = ''
      let lang = []
      for (var index = 0; index < this.multiData.length; index++) {
        var v = this.multiData[index]
        if (!v.language) {
          err = '语言不能为空！'
          break
        }
        if (lang.includes(v.language)) {
          err = '语言不能重复！'
          break
        }
        lang.push(v.language)
        if (!v.release_describe) {
          err = '文本说明不能为空'
          break
        }
        if (!v.content) {
          err = '发布内容不能为空'
          break
        }
        if (v.contentTxt.length > 500) {
          err = '发布内容字符不能超过500字'
          break
        }
      }
      if (err) {
        this.$message.error(err)
        return
      }
      console.log(this.multiData)
      this.content = this.multiData[0].content.replace('<p></p>', '')
      this.editorContent = this.content
      this.getContentTxt = this.multiData[0].contentTxt
      this.release_describe = this.multiData[0].release_describe
      this.multilingualDialog = false
    }
  }
}
</script>

<style lang="scss">
.el-tooltip__popper{
  max-width: 480px;
}
.multilingualDialog{
  .el-dialog__body{
    padding: 20px;
  }
  .add-language-btn{
    margin-top: 15px;
  }
  .el-table{
    border: none;
    width: 100%;
    table{
      border-collapse: collapse;
    }
    .el-table__header{
      border-collapse: collapse;
    }
    .cell{
      font-size: 12px;
      color: #475669;
      >span{
        font-size: 12px;
      }
    }
    th{
      padding: 8px 0;
      background: #F0F5FB;
      border: 1px solid #e7e7e7;
      border-color: #e7e7e7;
    }
    td{
      border-color: #e7e7e7;
      padding: 5px 0;
    }
    .el-table__body{
      border-left: 1px solid #e7e7e7;
    }
    .el-table__body-wrapper{
      overflow-y: auto;
      max-height: 500px;
    }
    .el-icon-delete{
      position: absolute;
      color: #ff4949;
      cursor: pointer;
    }
  }
}
.choose-language-box{
  .el-dropdown-menu__item{
    >div{
      display: flex;
      .span1{
        width: 80px;
      }
      .span2{
        color: #bbb;
        flex:1;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/version/platform-message.vue